// removed by extract-text-webpack-plugin
module.exports = {"menuIcon":"SideBar__menuIcon__1LIdu","sidebar_items":"SideBar__sidebar_items__284uo"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/SideBar/SideBar.css
// module id = 32
// module chunks = 0